import React from 'react';
import {Field} from 'redux-form';
import classNames from 'classnames';

import Avatar from 'components/Avatar';
import Label from 'components/Label';
import FormField from 'components/FormField';
import {CheckBoxField} from 'components/Fields';

import './styles.css';

export const initialValues = () => ({
  primaryTenant: true,
  secondaryTenant: true
});

const TenantsSection = ({
  primaryTenant,
  secondaryTenant,
  disablePrimaryTenantRemoval
}) => (
  <div className="TenantsSection">
    <Label>Booking Members</Label>
    <div className="container">
      <FormField
        className={classNames({
          disabled: disablePrimaryTenantRemoval
        })}>
        <div className="avatarAndFullNameContainer">
          <Avatar
            className="avatar"
            initials={primaryTenant.initials}
            url={
              primaryTenant.internalAvatarCropped || primaryTenant.avatarCropped
            }
            width={100}
          />
          <Label>{primaryTenant.fullName}</Label>
        </div>
        <Field
          name="primaryTenant"
          component={CheckBoxField}
          disabled={disablePrimaryTenantRemoval}
        />
      </FormField>
      {secondaryTenant && (
        <FormField>
          <div className="avatarAndFullNameContainer">
            <Avatar
              className="avatar"
              initials={secondaryTenant.initials}
              url={
                secondaryTenant.internalAvatarCropped ||
                secondaryTenant.avatarCropped
              }
              width={100}
            />
            <Label>{secondaryTenant.fullName}</Label>
          </div>
          <Field name="secondaryTenant" component={CheckBoxField} />
        </FormField>
      )}
    </div>
  </div>
);

export default TenantsSection;
